
window.PackAndMoveBookNow = {

    init() {
        const button = document.querySelector("[data-book-now]");

        if (!button) return;

        button.addEventListener(
            "click",
            this.submit.bind(this)
        );
    },

    async submit() {
        const booking = window.packAndMoveBooking;

        if (!booking) {
            console.error("Booking object not found.");
            return;
        }

        /*
        |--------------------------------------------------------------------------
        | Elevator Confirmation
        |--------------------------------------------------------------------------
        */

        const deliveryNo =
            booking.delivery?.address?.elevator === "No";

        const moveNo =
            booking.move?.address?.elevator === "No";

        if (
            (deliveryNo || moveNo) &&
            !booking.elevator?.confirmed
        ) {
            window.PackAndMoveElevatorModal.open();
            return;
        }

        console.log("Pack & Move Booking", booking);

        /*
        |--------------------------------------------------------------------------
        | Shared Batch ID
        |--------------------------------------------------------------------------
        */

        const batchId =
            "pack-move-" +
            Date.now() +
            "-" +
            Math.random().toString(36).slice(2, 9);

        console.log("Pack & Move Batch ID:", batchId);

        /*
        |--------------------------------------------------------------------------
        | Format Address
        |--------------------------------------------------------------------------
        */

        function formatAddress(address) {
            return [
                address.line1,
                address.line2,
                address.unit,
                address.postcode
            ]
                .filter(Boolean)
                .join("\n");
        }

        /*
        |--------------------------------------------------------------------------
        | Format Date
        |--------------------------------------------------------------------------
        */

        function formatCartDate(date) {
            if (!date) return "";

            const parsedDate =
                date instanceof Date
                    ? date
                    : new Date(date);

            if (Number.isNaN(parsedDate.getTime())) {
                return "";
            }

            return parsedDate.toLocaleDateString(
                "en-SG",
                {
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                }
            );
        }

        /*
        |--------------------------------------------------------------------------
        | Main Product Properties
        |--------------------------------------------------------------------------
        */

        const properties = {
            "batch_id": batchId,

            "Moving From":
                booking.property?.from || "",

            "Moving To":
                booking.property?.to || "",

            "Package":
                booking.package?.title || "",

            "Delivery Date":
                formatCartDate(booking.delivery?.date),

            "Move Date":
                formatCartDate(booking.move?.date),

            "Container Collection Date":
                formatCartDate(
                    booking.containerCollectionDate
                ),

            "Delivery Full Name":
                booking.delivery?.address?.fullName || "",

            "Delivery Phone":
                booking.delivery?.address?.phone || "",

            "Delivery Address":
                formatAddress(
                    booking.delivery?.address || {}
                ),

            "Delivery Elevator":
                booking.delivery?.address?.elevator || "",

            "Move Full Name":
                booking.move?.address?.fullName || "",

            "Move Phone":
                booking.move?.address?.phone || "",

            "Moving Address":
                formatAddress(
                    booking.move?.address || {}
                ),

            "Move Elevator":
                booking.move?.address?.elevator || ""
        };

        /*
        |--------------------------------------------------------------------------
        | Elevator Charge
        |--------------------------------------------------------------------------
        */

        console.log("Elevator object:", booking.elevator);

        if (
            booking.elevator &&
            booking.elevator.required &&
            booking.elevator.variantId
        ) {
            const response = await fetch("/cart/add.js", {
                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },

                body: JSON.stringify({
                    id: Number(booking.elevator.variantId),
                    quantity: 1,

                    properties: {
                        "batch_id": batchId
                    }
                })
            });

            if (!response.ok) {
                const error = await response.json();

                console.error(
                    "Elevator add failed",
                    error
                );
            }
        }

        /*
        |--------------------------------------------------------------------------
        | Extended Container Rental
        |--------------------------------------------------------------------------
        */

        const extendedRentalDays =
            Number(booking.extendedRentalDays) || 0;

        if (extendedRentalDays > 0) {
            const rentalProperties = {
                "batch_id": batchId,

                "Rental Days":
                    String(extendedRentalDays),

                "Rental Rate":
                    "$10.00 / day",

                "Move Date":
                    formatCartDate(booking.move?.date),

                "Container Collection Date":
                    formatCartDate(
                        booking.containerCollectionDate
                    )
            };

            console.log(
                "Adding Extended Container Rental:",
                {
                    days: extendedRentalDays,
                    variantId: 43161728647243,
                    properties: rentalProperties
                }
            );

            const rentalResponse = await fetch(
                "/cart/add.js",
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },

                    body: JSON.stringify({
                        id: 43161728647243,

                        quantity:
                            extendedRentalDays,

                        properties:
                            rentalProperties
                    })
                }
            );

            if (!rentalResponse.ok) {
                const rentalError =
                    await rentalResponse.json();

                console.error(
                    "Extended Container Rental add failed",
                    rentalError
                );

                return;
            }

            console.log(
                "Extended Container Rental added:",
                extendedRentalDays,
                "day(s)"
            );
        }

        /*
        |--------------------------------------------------------------------------
        | Add Main Product
        |--------------------------------------------------------------------------
        */

        if (!window.ExXtraAddToCart) {
            console.error(
                "ExXtraAddToCart helper not found."
            );

            return;
        }

        await window.ExXtraAddToCart.add({
            variantId: booking.package.id,

            quantity: 1,

            properties: properties,

            /*
            |----------------------------------------------------------------------
            | Checkout Address
            |----------------------------------------------------------------------
            */

            address: booking.delivery.address,

            service: "pack-and-move"
        });
    }
};

document.addEventListener(
    "DOMContentLoaded",
    () => {
        window.PackAndMoveBookNow.init();
    }
);
